import { Header } from 'main/header';
import { Footer } from 'main/footer';
import { Toolbar } from 'js/toolbar/toolbar';
import subCategoryStore from 'js/stores/store';

import React from 'react';

let hide = item => {
  let element = document.getElementById('container-header');
  element.style.display = 'none';
};

export class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...subCategoryStore.getState()
    };
    subCategoryStore.subscribe(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    this.setState(subCategoryStore.getState());
  }
  render() {
    let headerText = () => {
      if (window.location.hash.length <= 3) {
        return (
          <div id='container-header' className='app-info'>
            <div onClick={hide.bind(this)} className='close'></div>

            <p>
              <b>How to use the tool?</b> Symbols are organized by category
              represented by the cards below. Click on the category of interest
              to review the symbols. You can also search for specific symbols by
              keyword in the search field to the right.
            </p>
            <p>
              <b>Want to download the symbols?</b> Click the arrow next to the
              category name of interest and select Download Pack. This will
              provide you with the Style Sheet, fonts, and image files for those
              symbols.
            </p>
          </div>
        );
      } else {
        return <div></div>;
      }
    };
    return (
      <div id='page' className='app hfeed site'>
        <div id='container'>
          <div className='header-container'>
            <Header />
            <div id='page-bg'></div>
          </div>
          <div className='content-container'>
            {headerText()}
            <Toolbar />
            {this.props.children}
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/main/container.js